import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress, Stack, TextField } from "@mui/material";
import { useQuery } from "react-query";
import axiosClient from "../../../../../../../../../../lib/axios";
import { IDataListaTitulosReceber } from "../../../../../../../../../../types/api/financeiro/pesquisar-titulos-receber";
import { useFormContext } from "react-hook-form";
import { useMemo, useState } from "react";
import { Moment } from "moment";
import BasicDatePicker from "../../../../../../../../../../components/BasicDatePicker";
import { SimulacaoTitulo } from "../../../../../../../../../../types/api/financeiro/simular-recebimento-titulos";
import { formatarValorMonetario } from "../../../../../../../../../../helpers/masks";
import PaperDraggable from "../../../../../../../../../../components/PaperDraggable";


export default function DialogSimularValor({
    open,
    handleClose,
    handleSimular,
}: DialogSimularValorProps
) {
    const { getValues, watch } = useFormContext();
    const titulos: IDataListaTitulosReceber[] = getValues("selecionar_titulos");

    const [dataReceb, setDataReceb] = useState<Moment | null>(watch("finalizacao.data_recebimento"));

    //Querys e mutations
    const { data, isLoading } = useQuery({
        queryKey: ["simular-recebimento-titulos", titulos, dataReceb],
        queryFn: () =>
            axiosClient.get("financeiro/contas-receber/simular-recebimento-titulos", {
                params: {
                    titulos: titulos.map((titulo) => titulo.id),
                    data_recebimento: dataReceb?.format("YYYY-MM-DD"),
                },
            }),
        enabled: Boolean(titulos.length && dataReceb),
    });

    const dataDetalhes: SimulacaoTitulo = useMemo(() => data?.data, [data]);

    const totalAtualizado = useMemo(() => {
        if (!dataDetalhes) return 0;
        return dataDetalhes.titulos.reduce((total, item) => {
            return total + item.valor_atualizado;
        }, 0);
    }, [dataDetalhes]);

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            fullWidth
            maxWidth="xs"
            PaperComponent={PaperDraggable}
            aria-labelledby="draggable-dialog-title"
        >
            <DialogTitle
                style={{ cursor: "move" }}
                id="draggable-dialog-title"
            >
                Simular Valor
            </DialogTitle>
            <DialogContent>
                <Stack direction={'column'} spacing={2} mt={1}>
                    <BasicDatePicker
                        value={dataReceb}
                        label="Data simulada"
                        onChange={(data) => setDataReceb(data as Moment)}
                        formatString="DD/MM/YYYY"
                    />
                    <Box>
                        <TextField
                            fullWidth
                            disabled={isLoading}
                            label="Valor simulado"
                            value={formatarValorMonetario(totalAtualizado)}
                            slotProps={{ input: { readOnly: true } }}
                        />
                        {isLoading && (
                            <LinearProgress sx={{ mt: -0.5 }} />
                        )}
                    </Box>
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Fechar
                </Button>
                <Button
                    variant="contained"
                    onClick={() => handleSimular(totalAtualizado)}
                    color="primary"
                    disabled={isLoading}
                >
                    Simular
                </Button>
            </DialogActions>
        </Dialog>
    )
}

interface DialogSimularValorProps {
    open: boolean;
    handleClose: () => void;
    handleSimular: (valorSimulado: number) => void;
}
